'use strict';

(function () {

  angular
    .module('specsguardApp')
    .component('sgProjectModules', {
      bindings: {
        project: '<',
        tab: '<',
        updateProject: '&'
      },
      templateUrl: 'app-legacy/project/administration/project.modules.html',
      controller: 'ProjectModulesCtrl'
    });

})();
